const blockSliderNews = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const blocks = document.querySelectorAll(".block-slider-news__section");
    if (blocks.length > 0) {
      blocks.forEach((block) => {
        const slider = new Swiper(block.querySelector('.block-slider-news__slider'), {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: block.querySelector(".swiper-button-next"),
            prevEl: block.querySelector(".swiper-button-prev"),
          },
          breakpoints: {
            768: {
              slidesPerView: "auto",
              spaceBetween: 20,
            },
          },
        });
      });
    }
  });
};

export default blockSliderNews;